import { BlogPost } from '../../../types';

// Dynamic import: mock-data.ts carries every inline blog article (~72 kB
// gzipped) and a static import shipped it inside the ENTRY bundle to every
// visitor (audit: 400+ kB unused JS). The local repo is a dev/offline
// fallback — production uses the D1 repo and never loads this chunk.
const loadMockBlogPosts = () =>
    import('../../data/mock-data').then(m => m.MOCK_BLOG_POSTS);

export class LocalMiscRepo {
    // --- Blog ---
    async getBlogPosts(): Promise<BlogPost[]> {
        return loadMockBlogPosts();
    }

    async getBlogPost(id: number): Promise<BlogPost | undefined> {
        return (await loadMockBlogPosts()).find(p => p.id === id);
    }

    // --- Settings ---
    async getSetting(key: string): Promise<string | null> {
        return localStorage.getItem(`espacero_setting_${key}`);
    }

    async setSetting(key: string, value: any): Promise<boolean> {
        try {
            localStorage.setItem(`espacero_setting_${key}`, String(value));
            return true;
        } catch { return false; }
    }
}
